import { Icon, type IconName } from './Icon.js';

export interface TabItem<T extends string> {
  id: T;
  label: string;
  icon: IconName;
}

/** Bottom tab bar (at most five items), translucent over the content, clear of the home indicator. */
export function TabBar<T extends string>({
  tabs,
  active,
  onChange,
  label,
}: {
  tabs: readonly TabItem<T>[];
  active: T;
  onChange: (id: T) => void;
  label: string;
}) {
  return (
    <nav className="tabbar" aria-label={label}>
      <ul className="tabbar-list">
        {tabs.map((tab) => (
          <li key={tab.id}>
            <button
              type="button"
              className="tab"
              aria-current={tab.id === active ? 'page' : undefined}
              onClick={() => onChange(tab.id)}
              data-testid={`tab-${tab.id}`}
            >
              <Icon name={tab.icon} size="lg" />
              <span className="tab-label">{tab.label}</span>
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
}
